import { useEffect, useState } from 'react';
import './../../../App.css';
import { useNavigate } from 'react-router-dom';
import { baseInstance, authInstance, reAuthInstance, fileAuthInstance } from '../../../modules/api/api';
import Editor from './../../../components/EditorComponent/EditorComponentSmall';
import inputData from './../../../modules/inputData/inputData'


export default function ProductWrite(){
    const navigate = useNavigate();
    const category = localStorage.getItem('admin_selected')

    // Change Object
    let [dataObj, setDataObj] = useState({
        "category": 0,
        "partner": "",
        "product_related": "",
        "product_name": "",
        "detail": ""
    }); 
    
    // // GET API
    // const getAPI = async () => {
    //     try {
    //         const resp = await authInstance.get(`/product`)
    //         inputData(setDataObj,'data',resp.data);
    //     } catch (err) {
    //         console.log('Error >>', err)
    //     }
    // }
    // useEffect(() => {
    //     getAPI();
    // }, [])

    // Extract Category from DB
    // const [refresh, setRefresh] = useState(1);
    // const arrangeData = () => {
    //     const menu = []
    //     for (let i = 0; i < dataObj.data?.length; i++ ){
    //         // Extract Category data from DB
    //         const menu_exist = dataObj.data[i]?.category
    //         // Add Category that doesn't exist in an Array
    //         if (!menu.includes(menu_exist)) {
    //             menu.push(menu_exist)
    //         }
    //     }
    //     inputData(setDataObj, 'menu', menu)
    //     if (refresh == 1) {
    //         setTimeout(function(){
    //             setRefresh(refresh + 1)
    //         }, 500)
    //     }
    // }
    // useEffect(() => {
    //     arrangeData();
    // }, [refresh, dataObj.data])

    // Refresh Token
    const reAuthAPI = async () => {
        try {
            const resp = await reAuthInstance.get('/admin/refresh')
            .then ((resp) => {
                localStorage.setItem('access_token', resp.data.access_token)
            })
        } catch (err) {
            console.log('Error >>', err)
        }
    }
    useEffect(() => {
        reAuthAPI();
    }, [])

    // Show file link
    const showFileLink = async (e) => {
        e.preventDefault();
        const formData = new FormData()
        const nameArray = [];
        for (let i = 0; i < e.target.files.length; i++) { // 반복문으로 여러 파일을 데이터에 담기
            formData.append('files', e.target.files[i])
        }
        try {
            const resp = await fileAuthInstance.post('library/files', formData)
            console.log('success >>', resp.data.urls[0]);
            inputData(setDataObj,'fileLink',resp.data.urls[0]);
        } catch (err) {
            console.log('Error >>', err)
        }
    }

    // Upload files API
    const uploadFiles = async (e) => {
        e.preventDefault();
        const formData = new FormData()
        const nameArray = [];
        for (let i = 0; i < e.target.files.length; i++) { // 반복문으로 여러 파일을 데이터에 담기
            formData.append('files', e.target.files[i])
            nameArray.push(e.target.files[i].name)
        }
        inputData(setDataObj,'filename', nameArray)
        try {
            const resp = await fileAuthInstance.post('library/files', formData)
            console.log('success >>', resp.data);
            inputData(setDataObj,'file',resp.data)
        } catch (err) {
            console.log('Error >>', err)
        }
    }

    // POST API
    const today = new Date();
    const fetchAPI = async () => {
        try {
            const resp = await authInstance.post( '/product'
                , {
                    product_name: dataObj.product_name,
                    partner: dataObj.partner,
                    product_related: dataObj.product_related,
                    detail: dataObj.detail,
                    images: dataObj.file,
                    category: parseInt(dataObj.category),
                    // category: dataObj.new_menu ? dataObj.new_menu : dataObj.category,
                    date: String(today),
                }
            )
            alert('글이 등록되었습니다.')
            navigate('/admin/list')
            window.location.reload()
        } catch (err) {
            if (err.response.status === 400) {
                alert('토큰만료로 인해 재로그인이 필요합니다. (작성한 글은 임시저장 되었습니다)')
                navigate('/admin')
            } else {
                alert('서버 문제가 발생했습니다. 잠시 후 다시 시도해주세요');
            }
            console.log('Error >>', err)
        }
    }

    // [component] writing editor
    function onEditorChange(value) { 
        inputData(setDataObj,'detail',value)
    }

    return(
        <>
            <div className='admin'>
                <img src='/images/hero.jpeg' decoding='async' />
                <div className='admin-write__con'>
                    <div className='board-write__board-name'>
                        <span>{category} 작성</span>
                    </div>
                    <div className='board-write__header'>
                        <div className='board-write__select-con'>
                            <select
                                onChange={(e) => {inputData(setDataObj,'category',e.target.value)}}
                            >
                                {['비상통화장치', '도어컨트롤러', '비상제어 시스템', '통신제어 시스템', '안내장치', '기타 제품'].map((a,i)=>{
                                    return(<option value={i}>{a}</option>)
                                })}
                            </select>
                            
                            {/* <select
                                onChange={(e) => {inputData(setDataObj,'category',e.target.value)}}
                            >
                                {(dataObj.menu ? ['-',...dataObj.menu] : ['Loading...']).map((a,i)=>{
                                    return(<option value={a}>{a}</option>)
                                })}
                            </select>

                            <div className='board-write__new-menu'>
                                <input
                                    type= 'text'
                                    onChange={(e) => {inputData(setDataObj,'new_menu',e.target.value)}}
                                    className='board-write__header-input'
                                    placeholder='신규 카테고리'
                                    value={dataObj.new_menu}
                                />
                            </div> */}
                        </div>

                        <div className='board-write__header-title'>
                            <label>
                                <input
                                    type= 'text'
                                    onChange={(e) => {inputData(setDataObj,'product_name',e.target.value)}}
                                    className='board-write__header-input'
                                    placeholder='상품명'
                                    value={dataObj.product_name}
                                />
                            </label>
                        </div>
                    </div>
                    
                    <div className='board-write__content-con'>
                        <div className={`board-write__content-files`}>
                            <label for="input-file">파일 선택</label>
                            <span>{dataObj.fileLink ? dataObj.fileLink : '파일링크 보기'}</span>

                            <input
                            type= 'file'
                            onChange={(e) => {showFileLink(e)}}
                            id='input-file'
                            // multiple
                            />
                        </div>

                        <div className='board-write__content-item'>
                            {/* Do not place <Editor /> in label tag. (font-size error) */}
                            <Editor value={dataObj.detail} onChange={onEditorChange} />
                        </div>

                        <div className={`board-write__content-files`}>
                            <label for="input-file2">썸네일 선택</label>
                            <span>{dataObj.file ? dataObj.filename?.map((a,i)=>{return(<span>{a}</span>)}) : '등록 전'}</span>

                            <input
                            type= 'file'
                            onChange={(e) => {uploadFiles(e)}}
                            id='input-file2'
                            // multiple
                            />
                        </div>

                        <div className='board-write__btn-submit'>
                            <li></li>
                            <span onClick={()=>{fetchAPI()}}>등록하기</span>
                        </div>
                    </div>
                </div>
            </div>
       </>
    )
}